/**
 * API Configuration Constants
 */
export const API_CONFIG = {
  BASE_URL:
    import.meta.env.DEV
      ? '/api/v1'
      : (import.meta.env.VITE_API_BASE_URL || 'http://localhost:3001/api/v1'),
  TIMEOUT: Number(import.meta.env.VITE_API_TIMEOUT) || 30000,
} as const;

/**
 * Application Routes
 */
export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  DASHBOARD: '/dashboard',
  ADMIN_DASHBOARD: '/admin',
  VENDOR_DASHBOARD: '/vendor',
  PRODUCTS: '/products',
  PRODUCT_DETAIL: '/products/:productId',
  // Services entry should always use the booking category UI
  SERVICES: '/book-service/category',
  SERVICE_DETAIL: '/services/:serviceId',
  CART: '/cart',
  WISHLIST: '/wishlist',
  CHECKOUT: '/checkout',
  ORDERS: '/orders',
  ORDER_DETAIL: '/orders/:orderId',
  SERVICE_REQUESTS: '/dashboard/service-requests',
  BOOK_SERVICE: '/book-service',
  BOOK_SERVICE_CATEGORY: '/book-service/category',
  BOOK_SERVICE_DETAILS: '/book-service/details',
  SERVICE_REQUEST_QUOTES: '/service-requests/:requestId/quotes',
  VENDOR_AVAILABLE_REQUESTS: '/vendor/available-requests',
  VENDOR_SUBMIT_QUOTE: '/vendor/requests/:requestId/quote',
  VENDOR_MY_QUOTES: '/vendor/quotes',
  VENDOR_EDIT_QUOTE: '/vendor/quotes/:quoteId/edit',
  ADMIN_SERVICE_CATEGORIES: '/admin/service-categories',
  ADMIN_SERVICE_REQUESTS: '/admin/service-requests',
  REQUEST_PRODUCTS: '/products/request',
  MY_PRODUCT_REQUESTS: '/products/my-requests',
  VENDOR_PRODUCT_REQUESTS: '/vendor/product-requests',
  PROFILE: '/profile',
  SETTINGS: '/settings',
  SUPPORT: '/support',
  VENDOR_SUPPORT: '/vendor/support',
  ADMIN_SUPPORT: '/admin/support',
  NOT_FOUND: '/404',
} as const;

/**
 * Recommended image dimensions for uploads (width × height in pixels)
 * Using these sizes ensures images look sharp and consistent across the app
 */
export const IMAGE_DIMENSIONS = {
  /** Service images: 4:3 ratio for cards/detail. Upload at 1200×900 for best quality. */
  SERVICE: { width: 1200, height: 900, label: '1200 × 900 px (4:3)' },
  /** Product images: 1:1 ratio for listings */
  PRODUCT: { width: 1200, height: 1200, label: '1200 × 1200 px (1:1)' },
  /** Category/main service image: 4:3 ratio for hero cards */
  CATEGORY: { width: 800, height: 600, label: '800 × 600 px (4:3)' },
} as const;

/**
 * Storage Keys
 */
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'auth_token',
  REFRESH_TOKEN: 'refresh_token',
  USER_PREFERENCES: 'user_preferences',
  THEME: 'theme',
} as const;

/**
 * HTTP Status Codes
 */
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
} as const;

/**
 * Validation Rules
 */
export const VALIDATION = {
  PASSWORD_MIN_LENGTH: 8,
  USERNAME_MIN_LENGTH: 3,
  USERNAME_MAX_LENGTH: 20,
  EMAIL_REGEX: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
} as const;

/**
 * Feature Flags
 */
export const FEATURE_FLAGS = {
  ENABLE_ANALYTICS: import.meta.env.VITE_ENABLE_ANALYTICS === 'true',
  ENABLE_DEBUG_MODE: import.meta.env.VITE_ENABLE_DEBUG_MODE === 'true',
} as const;
